import {
  VENDOR_DASHBOARD_DATA,
  VENDOR_DASHBOARD_ERROR,
  VENDOR_DASHBOARD_LOADING,
} from "../actions/type";

const initialState = {
  data: null,
  date: "monthly",
  loading: false,
  error: "",
  requestId: 0,
};

export default function vendorDashboard(state = initialState, action) {
  switch (action.type) {
    case VENDOR_DASHBOARD_LOADING:
      return {
        ...state,
        date: action.payload.date,
        requestId: action.payload.requestId,
        loading: true,
        error: "",
      };
    case VENDOR_DASHBOARD_DATA:
      if (action.payload.requestId !== state.requestId) return state;
      return {
        ...state,
        data: action.payload.data,
        date: action.payload.date,
        loading: false,
        error: "",
      };
    case VENDOR_DASHBOARD_ERROR:
      if (action.payload.requestId !== state.requestId) return state;
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
}
